import { WORLD_EXPLORER_BY_ID } from '../components/worldExplorer/worldExplorerData';
import {
  hasPremium as readHasPremiumFromStore,
  isPremiumMockEnabled,
} from '../utils/premiumStore';
import { getPathLessons as getPathLessonIds } from '../utils/skillGraph';
import { getGuidedLesson } from '../utils/guidedLessonRegistry';

/** Resolve which learning path a guided lesson belongs to (for premium gating in dev). */
function pathIdForLesson(worldId, lessonId) {
  const world = WORLD_EXPLORER_BY_ID[worldId];
  for (const p of world?.learningPaths || []) {
    try {
      if (getPathLessonIds(worldId, p.id).includes(lessonId)) return p.id;
    } catch {
      /* ignore */
    }
  }
  return lessonId;
}

/**
 * Topics passes a path id; LessonPage passes lessonId. Resolve to lesson id(s) via paths.json
 * (or [pathIdOrLessonId] fallback) and honor per-lesson `free` from guided lesson JSON.
 */
function anyGuidedLessonMarkedFree(worldId, pathIdOrLessonId) {
  const ids = getPathLessonIds(worldId, pathIdOrLessonId);
  return ids.some((lessonId) => getGuidedLesson(worldId, lessonId)?.free === true);
}

/** Shown under locked lesson cards (parent-facing). */
export const PREMIUM_PARENT_COPY = 'Premium unlocks more guided learning activities.';

/** Primary label for the locked primary action (no payment flow yet). */
export const PREMIUM_CTA_LABEL = 'Unlock with Explore Premium';

/**
 * Free tier: first learning path in each explorer world only.
 * @param {string} worldId
 * @returns {string | null} path id
 */
export function getFreeTierPathIdForWorld(worldId) {
  const world = WORLD_EXPLORER_BY_ID[worldId];
  const first = world?.learningPaths?.[0];
  return first?.id ?? null;
}

/**
 * @param {string} worldId
 * @param {string} pathIdOrLessonId - learning path id (TopicsPage) or guided `lessonId` (LessonPage)
 * @param {{ hasPremium?: boolean }} [opts] - if `hasPremium` is omitted the
 *   mock premium flag from `premiumStore` is consulted when mock mode is on.
 * @returns {boolean}
 */
export function isLessonAccessible(worldId, pathIdOrLessonId, opts = {}) {
  if (!isPremiumMockEnabled()) return true;
  const pathId = pathIdForLesson(worldId, pathIdOrLessonId) || pathIdOrLessonId;
  const { hasPremium } = opts;
  const premiumActive = typeof hasPremium === 'boolean' ? hasPremium : readHasPremiumFromStore();
  if (premiumActive) return true;
  if (anyGuidedLessonMarkedFree(worldId, pathIdOrLessonId)) return true;
  const freePath = getFreeTierPathIdForWorld(worldId);
  return freePath != null && pathId === freePath;
}
